__turbopack_context__.v({
  "buttonsWrapper": "_0tjgfW_buttonsWrapper",
  "divider": "_0tjgfW_divider",
  "forgotPassword": "_0tjgfW_forgotPassword",
  "formHeader": "_0tjgfW_formHeader",
  "formWrapper": "_0tjgfW_formWrapper",
  "noAccount": "_0tjgfW_noAccount",
  "resendActivationLinkWrapper": "_0tjgfW_resendActivationLinkWrapper",
});
